<template>
  <div v-if="isShowHeader" id="navTitle">
    <em @click="back" />
    <span>{{ title }}</span>
    <img
      v-if="rightContent == 'problem'"
      class="right"
      src="@/assets/images/bank/a_top_problem.png"
      @click="rightClick"
    >
    <img
      v-if="rightContent == 'report'"
      class="right icFlash"
      src="@/assets/images/template/toolbar_refresh.png"
      @click="selectFlash"
    >
    <p
      v-if="rightContent == 'recharge' || rightContent == 'withdrawal' || rightContent == 'transfer'"
      @click="goRecord"
    >
      记录
    </p>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'Header',
  props: ['title', 'rightContent','backToHome'],
  computed: {
    ...mapState(['pageType'])
  },
  data() {
    return {
      isShowHeader: true,
      isShowBankPop: true,
      goBackHome: this.backToHome || false
    }
  },
  mounted() {
    if (this.pageType == 'app') {
      this.isShowHeader = false
      document.getElementById('content').style.paddingTop = '0'
    }
  },
  methods: {
    back() {
      if (this.rightContent == 'recharge') { this.$store.dispatch('setRechargeData', {}) }
      if (this.rightContent == 'withdrawal') { this.$store.dispatch('setWithdrawalData', {}) }
      if (this.rightContent == 'transfer') { this.$store.dispatch('setTransferData', {})}

      if (this.goBackHome) {
        this.$router.push({ path: '/home' })
        return
      }
      this.$router.go(-1)
    },
    rightClick() {
      this.$emit('bankNotice', this.isShowBankPop)
    },
    goRecord() {
      this.$bus.$emit('loading', false)
      if (this.rightContent == 'recharge') {
        this.$store.dispatch('setTimeData', new Date())
        this.$store.dispatch('setTabIndex', 0)
        this.$router.push({ path: '/home/record' })
      } else if (this.rightContent == 'withdrawal') {
        this.$store.dispatch('setTimeData', new Date())
        this.$store.dispatch('setTabIndex', 1)
        this.$router.push({ path: '/home/record' })
      } else if (this.rightContent == 'transfer') {
        this.$store.dispatch('setTimeData', new Date())
        this.$store.dispatch('setTabIndex', 2)
        this.$router.push({ path: '/home/record' })
      }
    },
    selectFlash() {
      this.$emit('flashList')
    }
  }
}
</script>
